module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.0221070e.webp";